// @flow
import $ from 'jquery';
import JQueryView from '../../../common/JQueryView';

export default class ShowAllDisclaimer extends JQueryView {
  constructor() {
    super();
    $('.show-all-disclaimer').on('click', function() {
      $('.disclaimer')
        .find('.d-none')
        .removeClass('d-none');
      this.remove();
      return false; // aタグのhref="#"を無効化
    });
  }
}
